import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { NavigationService } from '../service/navigation.service';
import { AuthService } from '../service/auth.service';

@Injectable({
    providedIn: 'root',
})
export class LoginG implements CanActivate {
    constructor(
        private navigationS: NavigationService,
        private authService: AuthService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        if (!this.authService.gUser) {
            return true;
        } else {
            this.navigationS.gotoDashboard(this.authService.gUser);
        }
    }
}
